import { usePostHog } from "posthog-js/react"
import { useEffect } from "react"
import { useGetCatalogUser } from "../api/catalogQueries"
import { initData, retrieveLaunchParams } from "@telegram-apps/sdk-react"
import * as Sentry from "@sentry/react"

export const useInitPostHog = () => {
  const posthog = usePostHog()
  const { user } = useGetCatalogUser()
  const launchParams = retrieveLaunchParams()
  const userData = initData.user()

  useEffect(() => {
    if (user) {
      const APPLICATION_ID = import.meta.env.VITE_CORE_API_APP_ID

      posthog.identify(
        `${user.id}-${APPLICATION_ID}`,
        {
          application_id: APPLICATION_ID,
          telegram_id: user.telegramId,
          user_id: user.id,
          username: userData?.username,
          tg_mini_app_platform: launchParams.tgWebAppPlatform,
          tg_mini_app_version: launchParams.tgWebAppVersion,
          start_param: initData?.startParam(),
        },
        {
          initial_application_id: APPLICATION_ID,
          initial_telegram_id: user.telegramId,
          initial_user_id: user.id,
          initial_username: userData?.username,
          initial_tg_mini_app_platform: launchParams.tgWebAppPlatform,
          initial_tg_mini_app_version: launchParams.tgWebAppVersion,
          initial_start_param: initData?.startParam(),
        }
      )

      Sentry.setUser({
        applicationId: APPLICATION_ID,
        telegramId: user.telegramId,
        userId: user.id,
      })
    }
  }, [posthog, user?.id])
}
